import HtmlElementMetaData from './HtmlElementMetaData';

const presets = [
  {
    type: HtmlElementMetaData.type,
    id: HtmlElementMetaData.id,
    layout: {
      x: 0,
      y: 0,
      width: 200,
      height: 200
    },
    compProps: {
      zIndex: 1,
      fontSize: '12px',
    },
    data: {
      rawHTML: 'Place your HTML code here',
    },
    hidden: false
  }
];

export default presets;
